import { createAction, props } from '@ngrx/store';

export const NotfLayoutMesgShowHide = createAction(
    '[NOTF-LAYOUT-MESG] Show/Hide Popin Messages',
    props<{ status: boolean }>()
);
